import React, { useState } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import {useDeleteAvailabilityMutation} from "../services/endpoints/user.api";

export default function CalendarWithModal({ events }) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [modalData, setModalData] = useState([]);
    const [deleteSlot, { isDeleteSlotLoading }] = useDeleteAvailabilityMutation(); // Hook RTK

    const availableDates = events.map(e => new Date(e.start).toDateString());

    const tileClassName = ({ date, view }) => {
        if (view === "month" && availableDates.includes(date.toDateString())) {
            return "bg-success-subtle border border-success rounded";
        }
    };

    const getEventsForDate = (date) => {
        return events
            .map((e, index) => ({ ...e, originalIndex: index }))
            .filter(e => new Date(e.start).toDateString() === date.toDateString());
    };

    const openModal = (date) => {
        const data = getEventsForDate(date);
        setSelectedDate(date);
        setModalData(data);

        const modal = new window.bootstrap.Modal(document.getElementById('calendarModal'));
        modal.show();
    };

    const handleDelete = async (index) => {
        try {
            const response = await deleteSlot({ index }).unwrap();

            setModalData(prev => prev.filter(slot => slot.originalIndex !== index));


            console.log("Slot eliminato:", index);
        } catch (error) {
            console.error("Errore durante l'eliminazione:", error);
        }
    };

    return (
        <div>
            <Calendar
                onClickDay={openModal}
                tileClassName={tileClassName}
            />

            <div className="modal fade" id="calendarModal" tabIndex="-1" aria-labelledby="calendarModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="calendarModalLabel">
                                Disponibilità – {selectedDate?.toLocaleDateString()}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                        </div>
                        <div className="modal-body">
                            {modalData.length > 0 ? (
                                <ul className="list-group">
                                    {modalData.map((slot, i) => (
                                        <li className="list-group-item d-flex justify-content-between align-items-center" key={i}>
                                            <span>
                                                {new Date(slot.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} –{" "}
                                                {new Date(slot.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                            </span>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDelete(slot.originalIndex)}
                                            >
                                                Elimina
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-muted">Nessuna disponibilità per questa data.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
